import { h } from 'preact';
import * as BaseComp from 'components/shared/grid/grid.js';
import ArticleThumb  from 'components/shared/articleThumb/articleThumb';
import HTML from 'components/core/html/html.js';
import Store from 'store/store';
import { accessNested } from 'utils/utils';
import s from 'components/shared/grid/grid.sss';

export default class Grid extends BaseComp.default {
	render(props) {
		const {
			dataObj,
			imageSrc,
			imageRoot,
			title,
			subtitle,
			copy,
			baseConfig,
			menu,
			pageId
		} = props;

		const { id } = accessNested(Store.get(), 'activePage');
		
		return (
			<div class={s.gridWrapper}>
				{
					imageSrc ? 
						<div>
							<img class={s.image} src={imageSrc} />
							<HTML tag='h1' markdown class={s.title}>{title}</HTML>
						</div>
						:
						<HTML tag='h1' markdown class={s.title}>{title}</HTML>
				}
				{subtitle && <HTML tag='h2' markdown class={s.subtitle}>{subtitle}</HTML>}
				<div class={s.contentWrapper}>
					{id === 'jobListings' && menu}
					<div class={s.grid}>
						{Object.keys(dataObj).map(data => {
							if (!dataObj[data]) return;
							let finalData = Object.assign({}, baseConfig, dataObj[data]);
							return (
								<ArticleThumb
									copy={copy}
									data={finalData}
									imageRoot={imageRoot}
									title={title}
									thumbClass={s.thumbGrid}
									pageId={pageId}
								/>
							);
						})}
					</div>
				</div>
			</div>
		);
	}
}
